<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                :filterOfBusinesses="true"
                :filterOfLots="false"
                :isShowCalendar="true"
                :isRequiredFarms="true"
                classBusinesses="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
                classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
              >
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>

        <!-- Tabla Principal -->
        <card v-if="hasData">
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="handleSearchQuery"
              class="mr-3 mt-4"
            />
            <master-table :infoTable="queriedData" :columns="tableColumns">
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow() || isDelete()"
                  @handleView="handleView"
                  @handleEdit="handleEdit"
                  @handleDelete="handleDelete"
                  :resizable="false"
                  :showOperationEdit="isUpdate()"
                  :viewingRecordId="rowData ? rowData.id : null"
                  fixed="right"
                  :minWidth="120"
                />
              </template>
            </master-table>
            <card-footer ref="cardfooter" :propPagination="pagination" />
            <export-tables
              :pdf="{
                filename: `${$t(
                  'generalcutting.detailed_general_cutting_report'
                )}_${dataFilter.datei}_${dataFilter.datef}.pdf`,
                route: 'summary/generalcutting/pdf/alldetailed',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
              :xls="{
                filename: `${$t(
                  'generalcutting.detailed_general_cutting_report'
                )}_${dataFilter.datei}_${dataFilter.datef}.xlsx`,
                route: 'summary/generalcutting/excel/alldetailed',
                paramMethod: 'POST',
                plusData: { ...getDataToExport },
              }"
            />
          </div>
          <not-index-permissions v-else />
        </card>

        <div v-if="details" class="col-12 text-center">
          <em
            class="nc-icon nc-stre-up"
            style="font-size: 25px; cursor: pointer"
            @click="handleViewDetails"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>

        <!-- Card que contiene las Tablas detalles -->
        <card v-if="details && reportData">
          <div class="row">
            <div class="col-12">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('common_words.inspection_related_information') }}:
              </p>
            </div>

            <div class="col-12 mb-2">
              <table aria-describedby="table-details" class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.farm') }}:</strong>
                      </h6>
                      {{ reportData.header.farm_name }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.date') }}:</strong>
                      </h6>
                      {{ reportData.header.save_date }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('generalcutting.cut_number') }}:</strong>
                      </h6>
                      {{ reportData.header.cut_numer }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.week') }}:</strong>
                      </h6>
                      {{ reportData.header.week }}
                    </td>
                    <!-- Boton del Mapa -->
                    <th>
                      <img
                        v-tooltip.top-center="
                          $t('common_words.geo_location_map')
                        "
                        style="width: 30px; height: 30px"
                        class="pointer"
                        src="/static/img/iconos/map.svg"
                        :alt="$t('common_words.geo_location_icon')"
                        @click="handleViewDetailMap()"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Contenedor mitad y mitad: General Detalles + Racimos Cortados -->
            <div
              v-if="
                details &&
                (generalDetailsTable.length > 0 ||
                  reportData.general_cluster_table)
              "
              class="row mt-3"
            >
              <!-- Tabla General Detalles -->
              <div class="col-12 col-lg-6 mb-3">
                <card v-if="generalDetailsTable.length > 0" class="h-100">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-normal mb-3">
                        {{ $t('common_words.details') }}
                      </h4>
                    </div>

                    <div class="col-12">
                      <el-table
                        :data="generalDetailsTable"
                        border
                        size="medium"
                        style="width: 100%"
                        :max-height="465"
                      >
                        <el-table-column
                          prop="label"
                          :label="$t('generalcutting.parameters')"
                          min-width="280"
                        >
                        </el-table-column>

                        <el-table-column
                          prop="value"
                          :label="$t('common_words.value')"
                          min-width="160"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <span>
                              {{ scope.row.value }}
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </card>
              </div>

              <!-- Tabla Racimos Cortados -->
              <div class="col-12 col-lg-6 mb-3">
                <card v-if="reportData.general_cluster_table" class="h-100">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-normal mb-3">
                        {{ $t('generalcutting.cluster_cut') }}
                      </h4>

                      <el-table
                        :data="reportData.general_cluster_table"
                        border
                        size="medium"
                        style="width: 100%"
                        :max-height="465"
                        :row-class-name="getRowClassSummary"
                      >
                        <el-table-column
                          prop="label"
                          :label="$t('common_words.age')"
                          min-width="180"
                        >
                          <template slot-scope="scope">
                            <div
                              v-if="!scope.row.is_total"
                              :style="{
                                backgroundColor: scope.row.color_code,
                                color: scope.row.color_text,
                                padding: '4px 8px',
                                fontWeight: 'bold',
                              }"
                            >
                              {{ scope.row.label }}
                            </div>

                            <div v-else style="font-weight: bold">
                              {{ scope.row.label }}
                            </div>
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="quantity"
                          :label="$t('common_words.quantity')"
                          min-width="120"
                          align="center"
                        >
                        </el-table-column>

                        <el-table-column
                          prop="calibration_average"
                          :label="$t('calibration.calibration')"
                          min-width="100"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <span v-if="scope.row.calibration_average !== null">
                              {{
                                Number(scope.row.calibration_average).toFixed(2)
                              }}
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
                </card>
              </div>
            </div>

            <!-- Relacion Cajas -->
            <div class="col-12 mt-3">
              <card v-if="details && reportData.general_boxes_table">
                <div class="row">
                  <div class="col-12">
                    <h4 class="font-weight-normal mb-3">
                      {{ $t('generalcutting.list_boxes') }}
                    </h4>

                    <el-table
                      :data="reportData.general_boxes_table"
                      border
                      size="medium"
                      style="width: 100%"
                      :max-height="350"
                      :row-class-name="getRowClassSummary"
                    >
                      <el-table-column
                        prop="box_name"
                        :label="$t('production.box')"
                        min-width="220"
                      >
                        <template slot-scope="scope">
                          <span
                            :style="{
                              fontWeight: scope.row.is_total
                                ? 'bold'
                                : 'normal',
                            }"
                          >
                            {{ scope.row.box_name }}
                          </span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="quantity"
                        :label="$t('production.crafted')"
                        min-width="120"
                        align="center"
                      >
                      </el-table-column>

                      <el-table-column
                        prop="rejected"
                        :label="$t('production.rejected_2')"
                        min-width="120"
                        align="center"
                      >
                      </el-table-column>

                      <el-table-column
                        prop="exported"
                        :label="$t('generalcutting.exported')"
                        min-width="120"
                        align="center"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </card>
            </div>
          </div>

          <export-tables
            :pdf="{
              filename: '',
              route: '',
              showPDFButton: false,
            }"
            :xls="{
              filename: `${$t(
                'generalcutting.detailed_general_cutting_report'
              )}_${dataFilter.datei}_${dataFilter.datef}.xlsx`,
              route: 'summary/generalcutting/excel/detailed',
              paramMethod: 'POST',
              plusData: { ...getDataToExportDetailed },
            }"
          />
        </card>

        <!-- Modal del Mapa -->
        <el-dialog
          :title="$t('common_words.geo_location_map')"
          :visible.sync="modals.map"
          width="80%"
          :before-close="handleCloseMap"
          class="zoom-map el-dialog-img-zoom"
        >
          <div ref="multipleMap" class="map"></div>
          <div id="toolbarDiv" class="esri-component esri-widget">
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import configTable from './general-cutting-report-table';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import { MixinExport } from 'src/mixins/mixin-export';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTable from 'src/mixins/mixin-table';
import { MixinNotification } from 'src/mixins/mixin-notification';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import { isset } from 'src/util/Util.js';
import paginationDataGeneralCuttingReport from './paginationDataGeneralCuttingReport';

export default {
  name: 'GeneralCuttingReport',

  components: {
    [Filter.name]: Filter,
  },

  data() {
    return {
      pagination: paginationDataGeneralCuttingReport.pagination,
      dataFilter: {
        farm: [],
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        datef: moment().format('YYYY-MM-DD'),
        bySel: null,
        calendar_sel: null,
      },

      activeName: 'filter',
      valueCollapse: null,

      tableData: [],
      tableColumns: [],
      searchQuery: '',
      fuseSearch: null,

      generalDetailsTable: [],
      generalClusterTable: [],
      generalBoxesTable: [],

      inspectionForm: {},

      hasData: false,

      reportData: null,
      details: false,

      // Propiedades para el mapa
      center: {
        lat: 0,
        lng: 0,
      },
      map: null,
    };
  },

  computed: {
    ...paginationDataGeneralCuttingReport.functions,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getDataToExport() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },
    getDataToExportDetailed() {
      return {
        header_info: {
          farm: this.reportData.header.farm_name,
          date_save: this.reportData.header.save_date,
          cut_number: this.reportData.header.cut_numer,
          week: this.reportData.header.week,
          observation: this.reportData.header.observation,
        },
        general_details_table: [
          {
            label: this.$t('generalcutting.production_area'),
            value: this.reportData.general_details_table.production_area,
          },
          {
            label: this.$t('generalcutting.traveled_area'),
            value: this.reportData.general_details_table.traveled_area,
          },
          {
            label: this.$t('generalcutting.percent_traveled_area'),
            value: this.reportData.general_details_table.percent_traveled_area,
          },
          {
            label: this.$t('generalcutting.percent_rejected_clusters'),
            value:
              this.reportData.general_details_table.percent_rejected_clusters,
          },
          {
            label: this.$t('generalcutting.cut_total_ratio'),
            value: this.reportData.general_details_table.cut_total_ratio,
          },
          {
            label: this.$t('generalcutting.processed_total_ratio'),
            value: this.reportData.general_details_table.processed_total_ratio,
          },
          {
            label: `${this.$t('generalcutting.average_cluster_weight')} (${
              this.reportData.general_details_table.unit_tara_weight
            })`,
            value: this.reportData.general_details_table.average_cluster_weight,
          },
          {
            label: `${this.$t('generalcutting.average_stem_weight')} (${
              this.reportData.general_details_table.unit_tara_weight
            })`,
            value: this.reportData.general_details_table.average_stem_weight,
          },
          {
            label: `${this.$t('generalcutting.average_weight_without_stem')} (${
              this.reportData.general_details_table.unit_tara_weight
            })`,
            value:
              this.reportData.general_details_table.average_weight_without_stem,
          },
          {
            label: this.$t('generalcutting.general_average_calibration'),
            value:
              this.reportData.general_details_table.general_average_calibration,
          },
          {
            label: this.$t('generalcutting.average_number_hands'),
            value: this.reportData.general_details_table.average_number_hands,
          },
          {
            label: `${this.$t('generalcutting.average_length_second_hand')} (${
              this.reportData.general_details_table.unit_tara_length
            })`,
            value:
              this.reportData.general_details_table.average_length_second_hand,
          },
          {
            label: `${this.$t('generalcutting.average_length_last_hand')} (${
              this.reportData.general_details_table.unit_tara_length
            })`,
            value:
              this.reportData.general_details_table.average_length_last_hand,
          },
          {
            label: this.$t('generalcutting.percent_cut_total_loss'),
            value: this.reportData.general_details_table.percent_cut_total_loss,
          },
          {
            label: this.$t('generalcutting.percent_processed_total_loss'),
            value:
              this.reportData.general_details_table
                .percent_processed_total_loss,
          },
          {
            label: this.$t('generalcutting.average_number_fingers_box'),
            value:
              this.reportData.general_details_table.average_number_fingers_box,
          },
          {
            label: this.$t('generalcutting.average_clusters_total_fingers'),
            value:
              this.reportData.general_details_table
                .average_clusters_total_fingers,
          },
          {
            label: this.$t('generalcutting.quantity_people_packing'),
            value:
              this.reportData.general_details_table.quantity_people_packing,
          },
          {
            label: this.$t('generalcutting.quantity_people_harvest'),
            value:
              this.reportData.general_details_table.quantity_people_harvest,
          },
          {
            label: this.$t('generalcutting.work_start_time'),
            value: this.reportData.general_details_table.work_start_time,
          },
          {
            label: this.$t('generalcutting.work_end_time'),
            value: this.reportData.general_details_table.work_end_time,
          },
        ],
        general_cluster_table: this.reportData.general_cluster_table || [],
        general_boxes_table: this.reportData.general_boxes_table || [],
      };
    },
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinNotification,
    MixinValidations,
    MixinExport,
    MixinTable,
    MixinMenu,
    MixinArcgisMap,
  ],

  watch: {
    '$i18n.locale': ['setupTable'],
  },

  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleSearchQuery(query) {
      this.searchQuery = query;
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      this.tableData = [];
      this.hasData = false;
    },

    setupTable() {
      const { Table } = configTable();
      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
    },

    handleView(index, row) {
      this.showHideLoading(true);

      this.rowData = {
        ...row,
      };

      this.details = false;
      this.reportData = null;
      this.generalDetailsTable = [];
      this.generalClusterTable = [];
      this.generalBoxesTable = [];

      Axios.getMasters(`summary/generalcuttingreport/reports/${row.id}`)
        .then((response) => {
          this.reportData = response.data.data || {};

          this.generalDetailsTable = this.transformDetailsTable(
            this.reportData.general_details_table
          );

          this.generalClusterTable =
            this.reportData.general_cluster_table || [];

          this.generalBoxesTable = this.reportData.general_boxes_table || [];

          this.details = true;

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(
            error.response.data.message || 'Error al generar el reporte'
          );
        });
    },

    handleEdit(_, row) {
      if (!(this.isCreate() || this.isUpdate())) return;

      const farmId = row.farm_id;
      const saveDate = row.date_save;

      sessionStorage.setItem(
        'generalCuttingEdit',
        JSON.stringify({
          farm_id: farmId,
          save_date: saveDate,
        })
      );

      this.$router.push({
        path: '/summary/generalcuttingcatch',
      });
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        try {
          element.show = true;
        } catch (error) {
          //
        }
      });
      if (!this.details) {
        this.rowData = null;
      }
    },

    handleDelete(index, row) {
      this.inspectionForm = Object.assign({}, row);
      SweetAlert.delete(
        `${i18n.t('generalcutting.report_general_cutting_date')}(${
          this.inspectionForm.date_save
        })`
      ).then((result) => {
        if (result.value) this.deleteGeneralCutting();
      });
    },

    deleteGeneralCutting() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        this.inspectionForm.route = 'summary/generalcutting/delete';
        Axios.destroyMaster(this.inspectionForm)
          .then((response) => {
            this.modifyTable(2, this.inspectionForm.id, response);
            this.showHideLoading();
            this.handleViewDetails();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    // Funcion para filtrar
    handleFilter(data) {
      this.dataFilter = {
        ...this.dataFilter,
        datef: data.datef,
        datei: data.datei,
        bySel: data.bySel,
        farm: data.farm,
        calendar_sel: data.calendar_sel,
      };
      this.tableData = [];
      this.hasData = false;

      this.searchedQuery = '';
      this.rowData = null;

      this.reportData = null;
      this.details = false;

      this.generalDetailsTable = [];
      this.generalClusterTable = [];
      this.generalBoxesTable = [];

      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;

      this.getData();
    },

    getData() {
      this.showHideLoading(true);

      let data = {
        ...this.dataFilter,
        route: 'summary/generalcuttingreport/filter',
      };

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }

      Axios.postMasters(data)
        .then((response) => {
          const res = response.data.data || [];
          this.tableData = res || [];
          this.hasData = this.tableData.length > 0;

          if (!this.hasData) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.showHideLoading();
            return;
          }

          // Search (filtro tabla)
          try {
            this.searchFuse(
              this.tableColumns.map((c) => c.prop),
              null,
              0.3
            );
          } catch (error) {
            console.log(error);
          }

          this.pagination.perPage = 10;
          this.pagination.currentPage = 1;
          this.searchQuery = '';

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message || 'Error');
        });
    },

    // Se transforman los campos para aplicar la traduccion de cada Parametro
    // verlos horizontalmente y ademas agregar unidad de Peso
    transformDetailsTable(data) {
      if (!data) return [];

      const fields = [
        'production_area',
        'traveled_area',
        'percent_traveled_area',
        'percent_rejected_clusters',
        'cut_total_ratio',
        'processed_total_ratio',
        'average_cluster_weight',
        'average_stem_weight',
        'average_weight_without_stem',
        'general_average_calibration',
        'average_number_hands',
        'average_length_second_hand',
        'average_length_last_hand',
        'percent_cut_total_loss',
        'percent_processed_total_loss',
        'average_number_fingers_box',
        'average_clusters_total_fingers',
        'quantity_people_packing',
        'quantity_people_harvest',
        'work_start_time',
        'work_end_time',
      ];

      return fields.map((field) => {
        let label = this.$t(`generalcutting.${field}`);

        const fieldsWithUnit = [
          'average_cluster_weight',
          'average_stem_weight',
          'average_weight_without_stem',
        ];

        const fieldsLengthUnit = [
          'average_length_second_hand',
          'average_length_last_hand',
        ];

        if (fieldsWithUnit.includes(field) && data.unit_tara_weight) {
          label = `${label} (${data.unit_tara_weight})`;
        }

        if (fieldsLengthUnit.includes(field) && data.unit_tara_length) {
          label = `${label} (${data.unit_tara_length})`;
        }

        return {
          label: label,
          value: data[field],
        };
      });
    },

    // Funcion para visualizar el Mapa
    handleViewDetailMap() {
      if (!this.hasLocationData()) {
        SweetAlert.warning(this.$t('boxinspection.no_locations_defined'));

        return;
      }

      this.modals.map = true;
      this.showHideLoading(true);
      let points = [];

      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;

      let pll = new Object();
      pll.lat = parseFloat(this.rowData.latitude);
      pll.lng = parseFloat(this.rowData.longitude);

      // Formatear fecha a YYYY-MM-DD
      const formattedDate = this.rowData.date_save
        ? moment(this.rowData.date_save).format('YYYY-MM-DD')
        : 'N/A';

      //Nombre de la finca
      const farmName = this.rowData.farm_name ? this.rowData.farm_name : 'N/A';

      // Crear título con la estructura solicitada
      pll.name = `${formattedDate}, ${farmName}`;
      points.push(pll);

      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          19
        );

        // Ajustar posición del toolbar del mapa
        const toolbarDiv = document.getElementById('toolbarDiv');
        if (toolbarDiv) {
          toolbarDiv.style = 'top: 16%;right: 18px;';
        }
        this.showHideLoading();
      }, 10);
    },

    handleCloseMap() {
      this.modals.map = false;
      // Limpiar el mapa si existe
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },

    hasLocationData() {
      if (!this.rowData) {
        return false;
      }

      const { latitude, longitude } = this.rowData;

      return isset(latitude) && isset(longitude);
    },

    getRowClassSummary({ row }) {
      if (row.is_total) {
        return 'row-total';
      }
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('summary');
  },

  destroyed() {
    this.deselectedItemOnMenu('summary');
  },
};
</script>
<style scoped>
::v-deep .row-total td {
  background: #f7f7f7;
  font-weight: bold;
}
</style>
